import { Link } from "react-router-dom";

const footerLinks = {
  guides: [
    { label: "Beginner Guide", href: "/vigorbuy-spreadsheet-guide" },
    { label: "Templates", href: "https://kaspreadsheet.com", external: true },
    { label: "Comparisons", href: "#comparison" },
    { label: "Safety Tips", href: "#safety" },
  ],
  resources: [
    { label: "Product Categories", href: "#categories" },
    { label: "Spreadsheet FAQ", href: "#faq" },
    { label: "Main Store", href: "https://kaspreadsheet.com", external: true },
    { label: "Vigorbuy Spreadsheet", href: "https://kaspreadsheet.com", external: true },
  ],
  legal: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms of Service", href: "#" },
    { label: "Disclaimer", href: "#" },
    { label: "Contact", href: "#" },
  ],
};

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-800 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-sm font-label">
                V
              </span>
              <span className="text-lg font-heading font-semibold text-background-50 whitespace-nowrap">
                Vigorbuy Spreadsheet
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60">
              Your ultimate resource for Vigorbuy Spreadsheet guides, templates, comparisons and expert tips to improve your data management workflow.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">
              Guides
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.guides.map((link) =>
                link.external ? (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">
              Resources
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.resources.map((link) =>
                link.external ? (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ) : (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                )
              )}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-label font-semibold text-background-50 mb-4">
              Legal
            </h4>
            <ul className="space-y-2.5">
              {footerLinks.legal.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/50">
            &copy; {new Date().getFullYear()} Vigorbuy Spreadsheet. All rights reserved.
          </p>
          <p className="text-xs text-background-50/50">
            This site is an independent resource and is not affiliated with or endorsed by any third-party spreadsheet providers.
          </p>
        </div>
      </div>
    </footer>
  );
}